<template>
    <div :class="paymentsListClass">
        <table>
            <tr v-for="option in field.options" :key="option.id">
                <td>
                    <div style="position:relative;padding-left:1.25rem">
                        <input
                            type="radio"
                            class="form-check-input"
                            :name="field.name"
                            :id="option.id"
                            :value="option.value"
                            v-model="selected"
                            v-on:change="fillOutFromRadio()"
                        >
                        <FieldLabel :label="option" :fieldId="option.id" :product="option"/>
                    </div>
                </td>
                <td>
                    <Quantity
                        v-if="optionSelected(option.value)"
                        :min="min"
                        :defaultQuantity="defaultQuantity"
                        :disableQuantity="field.product.disableQuantity"
                        v-on:filled-out="fillOutFromQuantity(option.value, $event)"
                    >
                    </Quantity>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
  import FieldLabel from '../FieldLabel';
  import Quantity from './Quantity';

  export default {
    props: {
      field: {},
      value: '',
    },
    data() {
      return {
        selected: '',
        min: 1,
        defaultQuantity: 1,
        filledOutData: {}
      };
    },
    methods: {
        optionSelected(value) {
            return this.selected == value;
        },
        fillOutFromRadio() {
            this.filledOutData = {};
            this.filledOutData[this.selected] = 1;
            this.$emit('filled-out', this.filledOutData);
        },
        fillOutFromQuantity(value, quantity) {
            this.filledOutData = {};
            this.filledOutData[value] = quantity;
            this.$emit('filled-out', this.filledOutData);
        }
    },
    computed: {
        paymentsListClass() {
            return {
                'payments-list-field': true,
                'with-quantity': !this.field.product.disableQuantity
            };
        }
    },
    components: {
      FieldLabel,
      Quantity
    },
  };
</script>

<style>
</style>
